export function getUserIdFromToken(accessToken) {
    var arrayToken = accessToken.split('.');
    var tokenPayload = JSON.parse(atob(arrayToken[1]));
    return tokenPayload.userId;
}
